// ══════════════════════════════════════════════════════
// PeptideVault v6.5 — Lab Marker Normalization (BN16)
// Canonical marker dictionary + alias management.
// ══════════════════════════════════════════════════════
function renderLabNormalizationTab() {
  var dict = (S.labMarkerDictionary || []).slice().sort(function(a, b) { return (a.canonicalName || '').localeCompare(b.canonicalName || '') })
  // Collect all raw marker names from lab results
  var rawNames = {}
  ;(S.labResults || []).forEach(function(p) { (p.markers || []).forEach(function(m) { rawNames[m.name] = (rawNames[m.name] || 0) + 1 }) })
  var unmapped = Object.keys(rawNames).filter(function(name) {
    return !dict.some(function(d) { return d.canonicalName.toLowerCase() === name.toLowerCase() || (d.aliases || []).some(function(a) { return a.toLowerCase() === name.toLowerCase() }) })
  })

  return '<div class="tab-content" style="animation:fadeIn .25s ease">' +
    '<div class="row" style="margin-bottom:16px"><h2 style="font-size:20px;font-weight:700">Lab Marker Dictionary</h2><div class="spacer"></div>' +
    '<button class="btn btn-primary btn-sm" onclick="openModal(\'addLabMarkerDef\')">' + ICONS.plus + ' Add Marker</button></div>' +
    (unmapped.length > 0 ? '<div class="card" style="margin-bottom:12px;padding:12px;border-left:3px solid var(--amber)">' +
      '<div style="font-size:12px;font-weight:600;color:var(--amber);margin-bottom:4px">' + unmapped.length + ' unmapped marker name(s)</div>' +
      '<div style="font-size:11px;color:var(--text3)">' + unmapped.map(function(n) { return esc(n) + ' (' + rawNames[n] + '\u00d7)' }).join(', ') + '</div>' +
      '<button class="btn btn-secondary btn-xs" style="margin-top:6px" onclick="autoCreateMarkerDefs()">Auto-create entries</button>' +
    '</div>' : '') +
    (dict.length === 0 ? '<div class="card"><div class="empty-state" style="padding:32px"><div class="empty-icon">\uD83E\uDDEA</div><p>No canonical markers defined</p></div></div>' :
      '<div class="card" style="padding:0;overflow:hidden"><table style="width:100%;border-collapse:collapse;font-size:13px">' +
        '<thead><tr style="border-bottom:1px solid var(--border)"><th style="padding:8px 14px;text-align:left;font-size:11px;font-weight:700;color:var(--text4);text-transform:uppercase">Canonical Name</th><th style="padding:8px 14px;text-align:left;font-size:11px;font-weight:700;color:var(--text4);text-transform:uppercase">Unit</th><th style="padding:8px 14px;text-align:left;font-size:11px;font-weight:700;color:var(--text4);text-transform:uppercase">Aliases</th><th style="padding:8px 14px;text-align:left;font-size:11px;font-weight:700;color:var(--text4);text-transform:uppercase">Category</th><th style="padding:8px 14px"></th></tr></thead><tbody>' +
        dict.map(function(d) {
          return '<tr style="border-bottom:1px solid var(--border2)"><td style="padding:8px 14px;font-weight:600">' + esc(d.canonicalName) + '</td>' +
            '<td style="padding:8px 14px;color:var(--text3)">' + esc(d.unit || '') + '</td>' +
            '<td style="padding:8px 14px;font-size:11px;color:var(--text3)">' + (d.aliases || []).map(function(a) { return esc(a) }).join(', ') + '</td>' +
            '<td style="padding:8px 14px;font-size:11px">' + esc(d.category || '') + '</td>' +
            '<td style="padding:8px 14px"><button class="btn btn-ghost btn-xs" onclick="deleteLabMarkerDef(\'' + d.id + '\')">' + ICONS.trash + '</button></td></tr>'
        }).join('') +
      '</tbody></table></div>') +
  '</div>'
}

function normalizeMarkerName(rawName) {
  var lower = (rawName || '').toLowerCase().trim()
  var match = (S.labMarkerDictionary || []).find(function(d) {
    return d.canonicalName.toLowerCase() === lower || (d.aliases || []).some(function(a) { return a.toLowerCase() === lower })
  })
  return match ? match.canonicalName : rawName
}

function autoCreateMarkerDefs() {
  var rawNames = {}
  ;(S.labResults || []).forEach(function(p) { (p.markers || []).forEach(function(m) { if (!rawNames[m.name]) rawNames[m.name] = m }) })
  var existing = (S.labMarkerDictionary || []).map(function(d) { return d.canonicalName.toLowerCase() })
  var existingAliases = [];(S.labMarkerDictionary || []).forEach(function(d) { (d.aliases || []).forEach(function(a) { existingAliases.push(a.toLowerCase()) }) })
  var added = 0
  Object.keys(rawNames).forEach(function(name) {
    if (existing.indexOf(name.toLowerCase()) >= 0 || existingAliases.indexOf(name.toLowerCase()) >= 0) return
    S.labMarkerDictionary.push({ id: uid(), canonicalName: name, unit: rawNames[name].unit || '', aliases: [], category: '' })
    added++
  })
  if (added > 0) { save(); showToast(added + ' marker(s) added'); render() }
  else showToast('All markers already mapped')
}

function saveLabMarkerDef() {
  var name = (document.getElementById('lmd-name') || {}).value || ''
  var unit = (document.getElementById('lmd-unit') || {}).value || ''
  var aliases = ((document.getElementById('lmd-aliases') || {}).value || '').split(',').map(function(a) { return a.trim() }).filter(Boolean)
  var category = (document.getElementById('lmd-category') || {}).value || ''
  if (!name) { showToast('Name required'); return }
  S.labMarkerDictionary.push({ id: uid(), canonicalName: name, unit: unit, aliases: aliases, category: category })
  save(); closeModal(); showToast('Marker definition added'); render()
}

function deleteLabMarkerDef(id) { S.labMarkerDictionary = (S.labMarkerDictionary || []).filter(function(d) { return d.id !== id }); save(); render() }

export { renderLabNormalizationTab, normalizeMarkerName, autoCreateMarkerDefs, saveLabMarkerDef, deleteLabMarkerDef }
